import { render } from "./SwitchMembers.vue?vue&type=template&id=2ef402f2&scoped=true"
import script from "./SwitchMembers.vue?vue&type=script&lang=js"
export * from "./SwitchMembers.vue?vue&type=script&lang=js"

import "./SwitchMembers.vue?vue&type=style&index=0&id=2ef402f2&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef402f2"]])

export default __exports__